import { ReactNode } from "react";
import { ValueOf } from "utils/typeCheck.utils";

import { Placement } from "@floating-ui/dom";

export const ARROW_POSITION = {
  BOTTOM: "bottom",
  TOP: "top",
  RIGHT: "right",
  LEFT: "left",
} as const;

export interface PortalProps {
  children?: ReactNode;
  className: string;
}

export interface TooltipProps {
  className?: string;
  portalClassName?: string;
  triggerElement: ReactNode;
  placement?: Placement;
  children: ReactNode;
  offsetY: number;
  offsetX?: number;
  enabledOnMobile?: boolean;
  disabled?: boolean;
}

export interface TooltipContentProps {
  children: ReactNode;
  className?: string;
  arrowPosition?: ValueOf<typeof ARROW_POSITION>;
}
